module.exports = __webpack_public_path__ + "static/img/TA3000.1a3eadf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/problem/TA3000.png
// module id = ThJD
// module chunks = 0